import { readable } from "svelte/store";

const businessLocations = readable(window.businessLocations);

export default businessLocations;
